import {doc, getDoc} from 'firebase/firestore'

import {TContentSettings} from '../types/types'
import {db} from './firebase'

export async function getContentSettings(): Promise<TContentSettings> {
  const ref = doc(db, 'settings', 'content')
  return getDoc(ref).then(doc => doc.data() as TContentSettings)
}
